/* eslint-disable class-methods-use-this */
import ImageLightbox from './ImageLightbox';

/**
 * Array of objects to loop over and check video hrefs against using the 'regex' values.
 */
const videoTypes = [
	// Video File.
	{
		regex: /(.mp4|.ogg|.webm)/,
		iframe: false,
		// Just return the original href for video files.
		getSrc: ({ href }) => href,
	},
	// YouTube Video.
	{
		regex: /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,
		iframe: true,
		// Return the embed URL using the matches.
		getSrc: ({ href, matches }) => {
			// Make sure this url isn't for a user profile or channel.
			if (href.match(/youtube.com\/user|youtube.com\/channel/) === null) {
				return `https://www.youtube.com/embed/${matches[1]}?autoplay=1&hd=1&rel=0`;
			}
			return false;
		},
	},
	// Vimeo Video.
	{
		regex: /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/,
		iframe: true,
		// Return the embed URL using the matches.
		getSrc: ({ matches }) => `https://player.vimeo.com/video/${matches[4]}?autoplay=1`,
	},
	// Wistia Video.
	{
		regex: /(?:https?:\/\/(.+)?(wistia.com|wi.st)\/(medias|embed)\/)(.*)/,
		iframe: true,
		// Return the embed URL using the matches.
		getSrc: ({ matches }) => `https://fast.wistia.net/embed/iframe/${matches[4]}?autoplay=1`,
	},
];

export default class VideoLightbox extends ImageLightbox {
	getImageLinkClass() {
		return 'play-btn';
	}

	getInnerHTML() {
		const href = this.el.getAttribute('href');
		let src = false;
		let iframe = true;

		// Loop over videoTypes until we have a src.
		for (let i = 0; i < videoTypes.length; i++) {
			const videoType = videoTypes[i];
			const matches = href.match(videoType.regex);
			if (matches !== null) {
				// Get the proper video/iframe src for the current video type.
				src = videoType.getSrc({ href, matches });
				// eslint-disable-next-line prefer-destructuring
				iframe = videoTypes[i].iframe;
			}

			if (src) {
				break;
			}
		}

		// Bail early if we don't have a src.
		if (!src) {
			return;
		}

		/**
		 * Determine if the video should be renderd in an <iframe> or <video> element
		 * MP4 need to be rendered in a <video> tag to prevent IE11 from prompting to open/download
		 *
		 * @see https://github.com/emagineusa/embark/issues/24
		 */
		let html = '';
		if (iframe) {
			html = `<iframe src="${src}" frameborder="0" allowfullscreen></iframe>`;
		} else {
			html = `<video preload="false" controls src="${src}"></video>`;
			// Override the afterOnShow method in order to trigger the video element to play.
			this.afterOnShow = () => {
				const video = this.lightboxEl.querySelector('video');
				if (video) {
					video.play();
				}
			};
		}

		// eslint-disable-next-line consistent-return
		return `<div class="basicLightbox__video"><div class="responsive-video">${html}</div></div>`;
	}

	// Override of ImageLigthbox addImageLinkClass for only videos with featured images.
	addImageLinkClass() {
		const resourceImage = this.el.querySelector('.resource-item__image');
		const promotionalItem = this.el.querySelector('.promotional-item__image--icon');

		if (this.image || resourceImage !== null || promotionalItem !== null) {
			this.el.classList.add(this.getImageLinkClass());
		}
	}
}
